import { render } from "./FileList.vue?vue&type=template&id=2dab5616&scoped=true"
import script from "./FileList.vue?vue&type=script&lang=js"
export * from "./FileList.vue?vue&type=script&lang=js"

import "./FileList.vue?vue&type=style&index=0&id=2dab5616&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dab5616"]])

export default __exports__